










import { SelectField } from './select-field';
export default SelectField;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/select-field.vue